import { useLanguage } from "../../../i18n/LanguageContext";

export default function ComparisonBlock({ block }) {
  const { language } = useLanguage();

  const c = block.content || {};
  const translated = block.translated_content || {};

  const getTranslation = (chineseValue, translatedValue) => {
    if (language === "zh") {
      return chineseValue || null;
    }

    if (language === "es" || language === "ru") {
      return translatedValue || null;
    }

    return null;
  };

  const leftTitleTranslation = getTranslation(
    c.left_title_zh,
    translated.left_title
  );

  const leftTextTranslation = getTranslation(
    c.left_text_zh,
    translated.left_text
  );

  const rightTitleTranslation = getTranslation(
    c.right_title_zh,
    translated.right_title
  );

  const rightTextTranslation = getTranslation(
    c.right_text_zh,
    translated.right_text
  );

  const sideStyle = {
    flex: "1 1 320px",
    padding: "18px",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "14px",
        flexWrap: "wrap",
        marginBottom: "14px",
      }}
    >
      <div style={sideStyle}>
        {/* Canonical English title */}
        <h3 style={{ marginTop: 0 }}>
          {c.left_title_en}
        </h3>

        {/* Selected-language title */}
        {leftTitleTranslation && (
          <div style={{ color: "#6b7280" }}>
            {leftTitleTranslation}
          </div>
        )}

        {/* Canonical English text */}
        <div
          style={{
            marginTop: "14px",
            lineHeight: "1.65",
          }}
        >
          {c.left_text_en}
        </div>

        {/* Selected-language text */}
        {leftTextTranslation && (
          <div
            style={{
              marginTop: "10px",
              color: "#6b7280",
              lineHeight: "1.65",
            }}
          >
            {leftTextTranslation}
          </div>
        )}
      </div>

      <div style={sideStyle}>
        {/* Canonical English title */}
        <h3 style={{ marginTop: 0 }}>
          {c.right_title_en}
        </h3>

        {/* Selected-language title */}
        {rightTitleTranslation && (
          <div style={{ color: "#6b7280" }}>
            {rightTitleTranslation}
          </div>
        )}

        {/* Canonical English text */}
        <div
          style={{
            marginTop: "14px",
            lineHeight: "1.65",
          }}
        >
          {c.right_text_en}
        </div>

        {/* Selected-language text */}
        {rightTextTranslation && (
          <div
            style={{
              marginTop: "10px",
              color: "#6b7280",
              lineHeight: "1.65",
            }}
          >
            {rightTextTranslation}
          </div>
        )}
      </div>
    </div>
  );
}